import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/store-indents")({
  component: () => <RouteGuard module="store_indents"><Outlet /></RouteGuard>,
});
